/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Latest_VersionInputs */



/**
* | output |
* | --- |
* | "Latest version: {version}" |
*
* @param {Latest_VersionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const latest_version = /** @type {((inputs: Latest_VersionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Latest_VersionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Dernière version : ${i?.version}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Neueste Version: ${i?.version}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Ultima versione: ${i?.version}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Последняя версия: ${i?.version}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Última versión: ${i?.version}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`最新版本：${i?.version}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`最新バージョン: ${i?.version}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`नवीनतम संस्करण: ${i?.version}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Última versão: ${i?.version}`)
	return /** @type {LocalizedString} */ (`Latest version: ${i?.version}`)
});